import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Icons/White/giftbox.svg'


const _withScopeId = n => (_pushScopeId("data-v-ea84556e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "target-graph" }
const _hoisted_2 = { class: "target" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Gift!"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "goal-text" }
const _hoisted_6 = { class: "target-text" }
const _hoisted_7 = {
  ref: "graph",
  class: "graph"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "target-overlay",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onGoalClick && _ctx.onGoalClick(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        (
                        _ctx.showRewards &&
                        _ctx.goalsEnabled &&
                        (_ctx.rewardEnabled || _ctx.isFrontlineManager)
                    )
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["giftbox", { enabled: _ctx.rewardEnabled, bounce: !_ctx.giftboxLoaded }])
            }, _hoisted_4, 2))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.scoreData?.['goalLabel'] ?? 'Goal'), 1),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.formatTarget), 1)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(['graph-container', { tall: _ctx.tall }])
    }, [
      _createElementVNode("canvas", _hoisted_7, null, 512)
    ], 2)
  ]))
}